import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../types";
import {
  CreateDiscussionBoard,
  GetDiscussionBoardData,
  GetDiscussionBoardDataParams,
  GetSingleDiscussionBoardData,
} from "../../../types/discussionBoard/discussionBoard";
import { CreateTrainingMaterial } from "../../../types/trainingMaterial/trainingMaterial";
import { handleApiError } from "../../../utils/errorHandler";

// create
export const createDiscussionBoardAsync = createAsyncThunk<
  null,
  PostRequest<CreateDiscussionBoard, CommonOthers>
>(
  "admin/createDiscussionBoard",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createDiscussionBoard, data, {
        headers: {},
      });

      reRender(true);
      toast("success", "Discussion create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Discussion create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllDiscussionBoardAsync = createAsyncThunk<
  GetCommonData<GetDiscussionBoardData>,
  Params<GetDiscussionBoardDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllDiscussionBoard", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetDiscussionBoardDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllDiscussionBoard, {
      params: { ...rest },
      headers: {},
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get Discussion fail");
    return rejectWithValue(error);
  }
});

// update
export const updateDiscussionBoardAsync = createAsyncThunk<
  null,
  PostRequest<CreateTrainingMaterial, GetSingleDataParams>
>(
  "admin/updateDiscussionBoard",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateDiscussionBoard}/${id}`, data, {
        headers: {},
      });

      reRender && reRender(true);
      toast("success", "Discussion update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Discussion update fail");
      return rejectWithValue(error);
    }
  }
);

// single
export const singDiscussionBoardAsync = createAsyncThunk<
  GetSingleDiscussionBoardData,
  Params<GetSingleDataParams>
>("admin/singDiscussionBoard", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(
      `${BASE_API.getSingleDiscussionBoard}/${params?.id}`,
      {
        headers: {},
      }
    );

    return data.data?.data as GetSingleDiscussionBoardData;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Single Discussion data get fail");
    return rejectWithValue(error);
  }
});


export const toggleLikeAsync = createAsyncThunk(
  "discussionBoard/toggleLike",
  async ({
    discussionBoardId,
      commentId,
      replyId,
  }: {
    discussionBoardId: string;
      commentId: string;
      replyId?: string;
  }) => {
      const { data } = await AXIOS.post(`${BASE_API.toggleLikeDiscussionBoard}`, {
        discussionBoardId,
          commentId,
          ...(replyId && { replyId }),
      });
      return data;
  }
);